export default {
  unseen: 'Nouveau',
  seen: 'Plus tôt',
  actionRequired: 'Actions requises',
  deleted: 'La notification a été supprimée',
  cancel: 'Annuler',
  noNotification: 'Aucune notification',
  delete: 'Supprimer',
};
